const selectors = ({ get }) => ({
    getToken: () => {
        return get('token');
    },
    getRole: () => {
        const userData = get('userData');
        return userData.role ? userData.role.roleType : '';
    }
})

export default selectors;
